import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ServerWelcomeChannelInfo {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export type GetServerWelcomeChannelInfoResult = IResult & ServerWelcomeChannelInfo;

export class GetServerWelcomeChannelInfoRequest extends Request<{}, GetServerWelcomeChannelInfoResult> {
  constructor() {
    super('getServerWelcomeChannelInfo', {});
  }
}
